// Galaxia Pro — Utilities (ESM, typed)
// Mirror of `../utils.jsx` for Vite/React 19 consumption.
// The original .jsx remains untouched for the standalone HTML sandbox.

import { useEffect, useState } from "react";

export const fmtCOP = (n: number): string =>
  // B8-03: el signo va ANTES del "$" para montos negativos (pérdidas P&L):
  // "-$5.000", no "$-5.000".
  (n < 0 ? "-" : "") + "$" + Math.round(Math.abs(n)).toLocaleString("es-CO");

export const fmtCOPshort = (n: number): string => {
  if (n >= 1_000_000) {
    return "$" + (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (n >= 1_000) {
    return "$" + Math.round(n / 1_000) + "K";
  }
  return "$" + n;
};

export const fmtDate = (d: string | number | Date): string =>
  new Date(d).toLocaleDateString("es-CO", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

export const fmtTime = (d: string | number | Date): string =>
  new Date(d).toLocaleTimeString("es-CO", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

export const cls = (
  ...parts: Array<string | false | null | undefined>
): string => parts.filter(Boolean).join(" ");

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false,
  );
  useEffect(() => {
    if (typeof window === "undefined") return;
    const m = window.matchMedia(query);
    const on = (): void => setMatches(m.matches);
    m.addEventListener("change", on);
    return () => m.removeEventListener("change", on);
  }, [query]);
  return matches;
}

export const BREAKPOINTS = {
  mobileSm: "(min-width: 360px)",
  mobile: "(min-width: 414px)",
  tablet: "(min-width: 768px)",
  tabletLg: "(min-width: 1024px)",
  desktop: "(min-width: 1280px)",
  desktopLg: "(min-width: 1440px)",
} as const;
